import getFetchOptions from 'utils/getFetchOptions';

import { handleResponse } from '../utils';
import { CreateMerchantPersonRequest, MerchantPerson, UpdateMerchantPersonRequest } from './merchant.persons.types';

export const getMerchantPersons = async (
  apiAprilBaseUri: string,
  merchantId: string,
): Promise<Array<MerchantPerson>> => {
  const options = await getFetchOptions('GET');

  return await fetch(`${apiAprilBaseUri}/merchants/${merchantId}/owners`, options).then(handleResponse);
};

export const createMerchantPerson = async (
  apiAprilBaseUri: string,
  merchantId: string,
  payload: CreateMerchantPersonRequest,
): Promise<string> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/merchants/${merchantId}/owners`, options).then(handleResponse);
};

export const updateMerchantPerson = async (
  apiAprilBaseUri: string,
  merchantId: string,
  personId: string,
  payload: UpdateMerchantPersonRequest,
): Promise<void> => {
  const options = await getFetchOptions('PUT', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/merchants/${merchantId}/owners/${personId}`, options).then(handleResponse);
};

export const deleteMerchantPerson = async (
  apiAprilBaseUri: string,
  merchantId: string,
  personId: string,
): Promise<void> => {
  const options = await getFetchOptions('DELETE');
  return await fetch(`${apiAprilBaseUri}/merchants/${merchantId}/owners/${personId}`, options).then(handleResponse);
};
